import { render, staticRenderFns } from "./InstrumentItem.vue?vue&type=template&id=5f81776e&"
import script from "./InstrumentItem.vue?vue&type=script&lang=js&"
export * from "./InstrumentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports